import { render, staticRenderFns } from "./AffiliatedJobsHeaderItem.vue?vue&type=template&id=36beee95&scoped=true"
import script from "./AffiliatedJobsHeaderItem.vue?vue&type=script&lang=ts"
export * from "./AffiliatedJobsHeaderItem.vue?vue&type=script&lang=ts"
import style0 from "./AffiliatedJobsHeaderItem.scss?vue&type=style&index=0&id=36beee95&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36beee95",
  null
  
)

export default component.exports